<template>
  <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color="var(--primary-color)"
    :is-full-page="fullPage"
  ></loading>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5><b>Manage Hospital Master</b></h5>
              <div class="flex align-items-center gap-3">
                <Button
                  label="New"
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-success"
                  v-tooltip.bottom="'Search'"
                  @click="openNew"
                />
                <Button
                  icon="pi pi-upload"
                  class="p-button-rounded p-button-help"
                  v-tooltip.bottom="'Export CSV'"
                  @click="exportCSV($event)"
                />
                <span>Total : {{ totalRecords }}</span>
              </div>
            </div>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3"
            >
              <!-- Filters Section -->
              <div class="flex flex-wrap gap-3">
                <!-- Name Filter -->
                <div class="field w-auto">
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      v-model="search_name"
                      v-tooltip.bottom="'search'"
                    />
                    <label for="name">Search</label>
                  </span>
                </div>
                <Button
                  icon="pi pi-search"
                  @click="search(1)"
                  class="p-button-rounded p-button-primary"
                  v-tooltip.bottom="'Search'"
                />
                <Button
                  icon="pi pi-refresh"
                  class="p-button-rounded p-button-danger"
                  v-tooltip.bottom="'Refresh'"
                  @click="search(2)"
                />
              </div>
            </div>
          </template>
          <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
          <Column header="Edit" style="max-width: 5rem" frozen>
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-primary"
                v-tooltip.bottom="'Edit Hospital'"
                @click="editProduct(slotProps.data)"
              />
            </template>
          </Column>
         
          <Column
            header="Status"
            style="max-width: 5rem"
            :field="columns[0]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge
                  class="btn_green"
                  :value="data.status"
                  severity="success"
                ></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge
                  class="btn_red"
                  :value="data.status"
                  severity="danger"
                ></badge
              ></span>
              <span
                v-else-if="data.status == 'Deleted' || data.status == 'Deleted'"
                ><badge
                  class="btn_red"
                  :value="data.status"
                  severity="danger"
                ></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column header="Sr No" style="max-width: 3rem">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="ID" style="max-width: 3rem" :field="columns[1]">
            <template #body="{ data }">
              {{ data.id }}
            </template>
          </Column>
          <Column
            header="Hospital Name"
            style="min-width: 5rem"
            :field="columns[1]"
          >
            <template #body="{ data }">
              {{ data.hospital_name }}
            </template>
          </Column>
          <Column header="District" style="min-width: 5rem" :field="columns[1]">
            <template #body="{ data }">
              {{ data.district }}
            </template>
          </Column>
          <Column header="Address" style="min-width: 10rem" :field="columns[1]">
            <template #body="{ data }">
              {{ data.address }}
            </template>
          </Column>
          
        </DataTable>
        <Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
          header="Hospital Details"
          :modal="true"
          class="p-fluid"
        >
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <!-- <img
              :src="'images/product/shoes.jpg'"
              :alt="product.image"
              width="150"
              class="mt-0 mx-auto mb-5 block shadow-2"
            /> -->
              </div>
              <div class="field">
                <label for="role">Hospital Name</label>
                <InputText
                  id="hospital name"
                  v-model.trim="product.hospital_name"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.hospital_name }"
                />
              </div>
              <div class="field">
                <label for="role">Hospital Marathi Name</label>
                <InputText
                  id="hospital name"
                  v-model.trim="product.hospital_name_mr"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !product.hospital_name_mr,
                  }"
                />
              </div>
              <div class="field">
                <label for="role">District</label>
                <InputText
                  id="District"
                  v-model.trim="product.district"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.district }"
                />
              </div>
              <div class="field">
                <label for="role">Address</label>
                <Textarea
                  id="address"
                  v-model.trim="product.address"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.address }"
                />
              </div>
              <!-- <div class="field">
                  <label for="name">Name</label>
                  <InputText
                    id="name"
                    v-model.trim="product.name"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.name }"
                  /> -->
              <!-- <small class="p-invalid" v-if="submitted && !product.name"
                    >Name is required.</small
                  > -->
              <!-- </div> -->
              <!-- <div class="field">
                  <label for="description">Description</label>
                  <Textarea
                    id="description"
                    v-model.trim="product.description"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.description }"
                  />
                </div>
                <div class="field">
                  <label for="link">Video Link</label>
                  <InputText
                    id="link"
                    v-model.trim="product.videolink"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.link }"
                  />
                </div> -->
              <!-- <div class="field">
                  <label for="status">Type</label>
                  <Dropdown
                    id="state"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                </div> -->
              <div class="field">
                <label for="status">Status</label>
                <Dropdown
                  id="status"
                  v-model="status"
                  :options="status_dropdownItems"
                  optionLabel="name"
                  filter
                  :class="{ 'p-invalid': submitted && !status }"
                ></Dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <Button
                v-if="product.id"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="addHospital"
              />
              <Button
                v-else
                label="ADD"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="addHospital"
              />
            </div>
            <div class="col-12 md:col-6">
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger mr-1 mb-1"
                @click="productDialog = false"
              />
            </div>
          </div>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteVideo"
            />
          </template>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";
// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      search_name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      status_dropdownItems: [
        { name: "Active", value: "1" },
        { name: "InActive", value: "2" },
        { name: "Deleted", value: "3" },
      ],
      status: null,
      products: [],
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: { name: "Active", value: "Active" },
      selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      productService: null,
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
    };
  },
  async created() {
    this.productService = new ProductService();
    this.initFilters();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      // this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async search(count) {
      if (count == 2) {
        this.search_name = "";
      }
      await this.get_list();
      await this.get_count();
    },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
        hospital_name: this.search_name,
      };
      this.loading = true;
      var promise = apis.HospitalList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
        hospital_name: this.search_name,
      };
      this.loading = true;
      var promise = apis.HospitalList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        //this.products = Array.isArray(response.data.items) ? response.data.items : [];
        this.products = response.data.data;
        this.products = response.data.data.map((item) => {
          // Map status values to human-readable strings
          return {
            ...item,
            status:
              item.status === 1
                ? "Active"
                : item.status === 2
                ? "InActive"
                : "Deleted",
          };
        });
        console.log("data", this.products);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async addHospital() {
      this.submitted = true;
      if (!this.product.hospital_name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter role name",
          life: 3000,
        });
        return false;
      }
      // if(!this.product.status)
      // {
      // this.$toast.add({
      //         severity: "error",
      //         summary: "error",
      //         detail: "Please select status",
      //         life: 3000,
      //       });
      //       return false;
      // }
      //edit
      if (this.product.id) {
        this.product.status = this.status.value;
        var data = {
          id: this.product.id,
          hospital_name: this.product.hospital_name,
          hospital_name_mr: this.product.hospital_name_mr,
          district: this.product.district,
          address: this.product.address,
          status: this.product.status,
          record_updated_by: localStorage.getItem("id"),
        };
        console.log("data", data);
        this.isLoadingModel = true;
        var promise = apis.InsertUpdateHospital(data);
        promise
          .then((responseapi) => {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              width: 350,
              text: responseapi.data.message,
            });
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            // this.$swal.fire(error.response.data);
            this.$swal.fire({
              icon: "error",
              title: "Error",
              width: 350,
              text: error.response?.data?.message,
            });
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          hospital_name: this.product.hospital_name,
          hospital_name_mr: this.product.hospital_name_mr,
          district: this.product.district,
          address: this.product.address,
          status: this.product.status,
          record_created_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promises = apis.InsertUpdateHospital(data1);
        promises
          .then((responseapi) => {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              width: 350,
              text: responseapi.data.message,
            });
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              width: 350,
              text: error.response?.data?.message,
            });
            this.get_list();
            this.get_count();
          });
      }
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.products[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.products.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      // this.selectstatus.value = this.product.type;
      // this.selectstatus.name = this.product.type;
      // this.selectstatus2.value = this.product.status;
      // this.selectstatus2.name = this.product.status;
      // this.file_attachment = this.product.image;
      if (this.product.status) {
        // Find the correct status object
        this.status =
          this.status_dropdownItems.find(
            (item) => item.name === this.product.status
          ) || null;
      }
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
    deleteVideo() {
      if (this.product.id) {
        var data = {
          Id: this.product.id,
        };
        this.isLoadingModel = true;
        var promise = apis.deletebatchmaster(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.status == 200) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  